import { render, staticRenderFns } from "./aboutus-8v.vue?vue&type=template&id=6f5af0ff&"
import script from "./aboutus-8v.vue?vue&type=script&lang=js&"
export * from "./aboutus-8v.vue?vue&type=script&lang=js&"
import style0 from "./aboutus-8v.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports